import {Box, Stack, useTheme} from "@mui/material";
import React from "react";
import {CervinoHeaderText} from "../components/typography/CervinoHeaderText";
import MarketingPhrasesRowV2 from "../components/marketing/MarketingPhrasesRowV2";
import iconUrl from "../assets/icons/SM_star.png";
import HistoryTimeLine from "../components/marketing/HistoryTimeLine";

import dividerImageVertical from "../assets/icons/design_6.png"
import dividerImageHorizontal from "../assets/icons/design_6_horizontal.png"

import SMFooter from "../components/marketing/SMFooter";


export default function EssencePage() {
    const theme = useTheme();

    return (
        <Stack>
            <Stack alignItems="center" textAlign="center">

                <Box paddingTop={{xs: 10, sm: 15}}>
                    <MarketingPhrasesRowV2
                        phrases={["Built by generations", "Rooted in Mexico"]}
                        iconSrc={iconUrl}
                        iconRepeat={2}
                        iconSize={{xs: 30, sm: 35}}
                        gap={{xs: 1, sm: 2}}
                        color={theme.palette.primary.main}
                        rotateIcon
                    />
                </Box>

                <CervinoHeaderText color={theme.palette.primary.main}>OUR STORY</CervinoHeaderText>


                <HistoryTimeLine dividerImageVertical={dividerImageVertical} dividerImageHorizontal={dividerImageHorizontal}></HistoryTimeLine>
            </Stack>

            <SMFooter></SMFooter>
        </Stack>
    );
}
